import React from "react";
import { LinkToStacked } from "../react-stacked-pages-hook";
import { Box, Text } from "theme-ui";
// import "./reference.css";
import { colors, typography } from "../../styles/theme";

const Reference = ({ node, isFirst, isLast }) => {
  return (
    <Box
      sx={{
        border: `1px solid ${colors.neutral200}`,
        borderLeft: 0,
        borderRight: 0,
        borderTop: isFirst ? 0 : null,
        borderBottom: isLast ? 0 : null,
        padding: "1rem",
      }}
    >
      <LinkToStacked to={node.slug} className="reference">
        <Box>
          <Text
            sx={{
              ...typography.textMd500,
              color: colors.primaryMain,
            }}
          >
            {node.title}
          </Text>
          {node.content}
        </Box>
      </LinkToStacked>
    </Box>
  );
};

export default Reference;
